export default __webpack_public_path__ + "static/media/mobile-menu.80912e2b.svg";